import { ERROR_MESSAGE_REQUIRED } from '../../config'
import { useUser } from '../../contexts/userContext'
import FormSlide from '../FormSlide'
import { callCompleteOnboarding } from './common'

export default function WorkingGroupContributionSlide (props) {
  const { user } = useUser()

  return (
    <FormSlide
      id='your-contribution'
      title='Tell us a little more about yourself.'
      stageName='Finding your place at Aragon'
      description='Here we would like to learn about your skillset, motivation, and passions. This will help us learn more about you, why you’re wanting to join the DAO and in what ways your talents can help us all move forward together.'
      formData={[
        {
          text: `How are your skills going to be specifically useful to the ${user?.workingGroup}?`,
          label: 'skills',
          placeholder: '',
          type: 'big-text-box',
          errorHandling: { required: ERROR_MESSAGE_REQUIRED }
        }
      ]}
      onFormSubmit={callCompleteOnboarding(user)}
      nextButtonText='Submit'
      {...props}
    />
  )
}
